import { connect } from 'react-redux';

import { removeError as onClose, connectionOnline, connectionOffline } from './actions.js';
import ErrorHandlerComponent from './error-handler-component.js';

function mapStateToProps(state) {
	return {
		error: state.session.errors,
	};
}

export default connect(mapStateToProps, {
	onClose,
	connectionOnline,
	connectionOffline,
})(ErrorHandlerComponent);
